// Wrapper Component for the Mantine Dropdown
import { ReactElement, ReactNode } from 'react';
import { Menu, ScrollArea } from '@mantine/core';

// Link to Mantine Menu Component:  https://mantine.dev/core/menu/
type Props = {
  target: ReactNode,
  children: ReactNode,
  width?: string,
  isScrollable?: boolean,
  scrollAreaHeight?: string,
  footer?: ReactNode,
  isOpen?: boolean,
  onClose?: () => void,
}

export function Dropdown({
  target,
  children,
  width,
  isScrollable = false,
  scrollAreaHeight,
  footer,
  isOpen = false,
  onClose,
} : Props): ReactElement {
  return (
    <Menu width={width} opened={isOpen} onClose={onClose} closeOnClickOutside withinPortal>
      <Menu.Target>
        {target}
      </Menu.Target>

      <Menu.Dropdown>
        {isScrollable ? (
          <ScrollArea type="scroll" h={scrollAreaHeight}>
            {children}
          </ScrollArea>
        ) : (
          children
        )}
        {footer && (footer)}
      </Menu.Dropdown>
    </Menu>
  );
}
